import { Icon } from '@infotech-soe/erp-ui-kit';
import { format } from 'date-fns';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { messages } from './messages';
import { useItemStyles } from './styles';
import { NotificationProps } from './types';

const Notification = (props: NotificationProps): React.JSX.Element => {
  const { kind, startTs, finishTs } = props;
  const { formatMessage } = useIntl();
  const classes = useItemStyles();

  return (
    <div className={classes[kind]}>
      <Icon
        className="m-mr-sm"
        name={kind === 'maintenance' ? 'warning' : 'alert'}
      />
      {formatMessage(messages[kind], {
        startTs: format(startTs, 'dd.MM.yyyy HH:mm'),
        finishTs: format(finishTs, 'dd.MM.yyyy HH:mm'),
      })}
    </div>
  );
};

export default memo(Notification);
